import { render, staticRenderFns } from "./TableCopySelected.vue?vue&type=template&id=4f1090b0&scoped=true"
import script from "./TableCopySelected.vue?vue&type=script&lang=js"
export * from "./TableCopySelected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1090b0",
  null
  
)

export default component.exports